import React, { Component } from 'react';

import { appInsights } from '@/services/Telemetry/AppInsights.service';
import { ExceptionTypes } from '@/config/LogEventTypes.config';
import { EnvUtils } from '@/utils/env.utils';
import styles from './error-handler.module.scss';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { getOrganisationId } from '@/utils/auth/organisation.utils';

interface IErrorHandlerProps {
  children: React.ReactNode;
}

interface IErrorHandlerState {
  error: Error | null,
}

export default class ErrorHandler extends Component<IErrorHandlerProps, IErrorHandlerState> {
  constructor(props: IErrorHandlerProps) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    if (EnvUtils.isProduction()) {
      window.onerror = async (event, source, lineno, colno, error) => {
        appInsights.trackException({ error }, {
          exceptionType: ExceptionTypes.JS_EXCEPTION,
          pageUrl: window.location.href,
          subscriptionid: await getSubscriptionId(),
          organisationid: await getOrganisationId(),
        });
      };
    }
  }

  static getDerivedStateFromError(error: any) {
    return { error };
  }

  componentDidCatch(error: Error) {
    const el = document.getElementById('ag-starter-spinner');

    if (el) {
      el.style.display = 'none';
    }

    this.setState({ error });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <div className={styles['error-handler']}>
          <h1>An unexpected error occurred in the application</h1>
          <h2>
            Please try to reload page. If it doesn&apos;t help,
            get in touch with development team and send them text below:
          </h2>

          <pre className="mt-50">
            {error?.stack}
          </pre>
        </div>
      );
    }

    return children;
  }
}
